import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/store';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

export const useFirstInvoicesList = (params: any = {}, onError?: any) => {
  const { page, limit, sortBy, search, sales_staff, previous_sales_staff, start_date, end_date, is_sales_staff_changed } = params;

  const requestParams = {
    page,
    limit,
    sortBy,
    search,
    sales_staff,
    previous_sales_staff,
    start_date,
    end_date,
    is_sales_staff_changed,
  };
  const requestUrl = REACT_APP_API_URL + '/first-invoices/list';
  const fetchData = async () => {
    const res = await axios.get<any>(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['first-invoices-list', params], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    staleTime: Infinity,
    retry: false,
  });
};

export const useSalesStaffList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { id: user?.company_id, limit: 1000 };
  const requestUrl = REACT_APP_API_URL + '/company/users/saleslist';
  const fetchData = async () => {
    const res = await axios.get<any>(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['sales-staff-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    staleTime: Infinity,
    retry: false,
    enabled: !!user?.company_id,
  });
};
